export default __webpack_public_path__ + "static/media/1213 knife block A top.da32d20c.png";